import React from 'react';

import { Box } from '@chakra-ui/react';

import {
  H2,
  PageHeaderWithIcon,
  WithResourceIcon,
} from 'components/DataDisplay';
import { IconTypes } from 'components/Icons';
import { Drawer } from 'components/Overlay';
import { CloudInsightList } from 'containers/App/CloudInsight/CloudInsightList';

interface CloudInsightDrawerProps {
  isOpen: boolean;

  onClose(): void;
}

export const CloudInsightDrawer = (props: CloudInsightDrawerProps) => {
  const { isOpen, onClose } = props;

  return (
    <Drawer
      isOpen={isOpen}
      onClose={onClose}
      styles={{
        drawer: {
          size: 'xl',
        },
        body: { paddingRight: 0, overflowY: 'auto' },
      }}
      closeButton
      header={
        <PageHeaderWithIcon
          iconType={IconTypes.BlueprintView}
          label="RUNTIME INSIGHTS"
        />
      }
      body={
        <Box minH="0" w="full">
          <CloudInsightList />
        </Box>
      }
    />
  );
};
